import { t } from './dictionary.js';

const numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'fr-CA');

/**
 * Builds the inner HTML for a single wind farm card (name, region, status,
 * specs). Shared between the list view and the map popup — see list.js's
 * renderItem() and map.js's renderPopup() — so both stay visually and
 * structurally identical. The caller owns the wrapper element (`<li>` for
 * the list, `<div>` for the popup).
 * @param {Object} params
 * @param {Object} params.item
 * @param {Object} params.labels
 * @returns {string}
 */
export function renderCard({ item, labels }) {
  const status = t('status')[item['statut-projet']] ?? item['statut-projet'];
  const operationStart = item['duree-operation-debut'];
  const operationEnd = item['duree-operation-fin'];
  const operationPeriod = operationStart
    ? (operationEnd ? `${operationStart} - ${operationEnd}` : `${labels.operationSincePrefix} ${operationStart}`)
    : null;

  const specs = [
    { label: labels.labelPower, value: item.mw ? `${numberFormat.format(item.mw)}\u00a0MW` : t('notAvailable') },
    { label: labels.labelOperationPeriod, value: operationPeriod || t('notAvailable') },
    item.proprietaires ? { label: labels.labelOwners, value: item.proprietaires.split(',').map((o) => o.trim()) } : null,
  ].filter(Boolean).map(({ label, value }) => `
    <div class="spec">
      <div class="spec__label">${label}</div>
      ${Array.isArray(value)
        ? `<ul class="spec__value">${value.map((o) => `<li>${o}</li>`).join('')}</ul>`
        : `<div class="spec__value">${value}</div>`}
    </div>`).join('');

  return `
    <div class="card__body">
      <div class="card__summary">
        <div class="card__name hq-titre5">${item[t('nameKey')] ?? item['nom-fr']}</div>
        <div class="card__region">${item.region}</div>
        <div class="card__status">${status}</div>
      </div>
      <div class="card__specs">${specs}</div>
    </div>`;
}
